module.exports = __webpack_public_path__ + "static/media/id-ID.1017687b.md";